class Header {
    constructor() {
        this.window = window;
        this.header = document.querySelector('.js-header');

        if (this.header) {
            this.changeHeaderStyle();
            this.initEvent();
        }
    }

    initEvent() {
        this.window.addEventListener('scroll', () => { this.changeHeaderStyle(); });
    }

    changeHeaderStyle() {
        if (this.window.pageYOffset > 25) {
            this.header.classList.add('fixed');
        } else {
            this.header.classList.remove('fixed');
        }
    }
}

const header = {
    init() {
        return new Header();
    },
};

export default header;
